/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { EmailTemplatesStoreRequest, EmailTemplatesStoreResponse } from '../types/EmailTemplatesStore'

/**
 * POST /email-templates
 * @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::store
 */
export async function emailTemplatesStore(
	data: EmailTemplatesStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailTemplatesStoreResponse>> {
	return axiosInstance.post('/email-templates', data, config)
}
